export function BlockDrawerGesture({children}: {children: React.ReactNode}) {
  return children
}
